import { UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { TicketTypeEnum } from './enums/ticket-type.enum';
import moment from 'moment';
import { omit } from 'lodash';

export class CheckListsValidators {
  static requiredIfLocal = (group: UntypedFormGroup): ValidationErrors => {
    const checklist = group.get('checklist').value;

    if (!checklist || checklist.ticket_type !== TicketTypeEnum.Local) {
      return null;
    }
    return group.get('hdTicketTypes').value ? null : { required: true };
  }

  static requiredArray = (control: UntypedFormControl): ValidationErrors => {
    if (!control.value || !Array.isArray(control.value)) {
      return null;
    }

    return control.value.length > 0 ? null : { required: true };
  }

  static dateRange = (): ValidationErrors => {
    const clearErrors = (dateGTECtrl, dateLTECtrl) => {
      dateGTECtrl.setErrors(dateGTECtrl.errors ? omit(dateGTECtrl.errors, ['isAfterLTE']) : null);
      dateLTECtrl.setErrors(dateLTECtrl.errors ? omit(dateGTECtrl.errors, ['isBeforeGTE']) : null);
    };

    return (group: UntypedFormGroup) => {
      const dateGTECtrl = group.get('hd_create_date__gte');
      const dateLTECtrl = group.get('hd_create_date__lte');

      if (!dateGTECtrl || !dateLTECtrl) {
        return null;
      }

      if (!dateGTECtrl.value || !dateLTECtrl.value) {
        clearErrors(dateGTECtrl, dateLTECtrl);
        return null;
      }

      const isLTEBefore = moment(dateLTECtrl.value).isBefore(dateGTECtrl.value);
      const isGTEAfter = moment(dateGTECtrl.value).isAfter(dateLTECtrl.value);

      if (!isLTEBefore && !isGTEAfter) {
        dateGTECtrl.setErrors(null);
        dateLTECtrl.setErrors(null);
        return null;
      }

      if (isGTEAfter) {
        dateGTECtrl.setErrors({ isAfterLTE: true });
      }

      if (isLTEBefore) {
        dateLTECtrl.setErrors({ isBeforeGTE: true });
      }

      return { ...dateGTECtrl.errors, ...dateLTECtrl.errors };
    };
  }
}
